import React from 'react'
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'

const DocumentCodeTable = ({ code }) => (
  <Table size="small" emptyMessage="Nenhum documento encontrado" noWrap>
    <TableHead>
      <TableRow>
        <TableCell width="50%">Código do Documento</TableCell>
        <TableCell width="25%">Versão</TableCell>
        <TableCell width="25%">Revisão</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      <TableRow>
        <TableCell width="50%">{code || 'Não coletado'}</TableCell>
        <TableCell width="25%">1</TableCell>
        <TableCell width="25%">0</TableCell>
      </TableRow>
    </TableBody>
  </Table>
)

export default DocumentCodeTable
